<script>
  import { createEventDispatcher } from "svelte";
  import Radio from "./Radio.svelte";

  // @ts-check

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** The list of radio buttons to display
   * @type {Array<{label: string; value: string}>} */
  export let options;

  /** The name of the radio button group
   * @type {string} */
  export let name;

  /**
   * The label for the entire radio group. Used only when the radio group is a part of a form.
   * @type {string}
   */
  export let label;

  /** Indicates whether the input field is required or not.
   * @type {boolean} */
  export let required = false;

  /** The error message to display
   * @type {string | undefined} */
  export let errorMessage = "";

  export let isInvalid = false;

  export let selection = null;

  /**
   * An optional CSS class to be applied to the component.
   * @type {string}
   */
  export let componentClass = "";

  const dispatch = createEventDispatcher();

  function handleChange(event) {
    options.forEach((option) => {
      if (option.id === event.target.id) {
        selection = option.value;
      }
    });

    if (required) {
      isInvalid = !event.target.checked;
    }

    dispatch("radioSelectionGroup", { selection, name });
  }
</script>

{#if label}
  <p class="pb-6 font-gotham-condensed text-body-m-xlarge font-bold">{label}</p>
{/if}

<div {id} role="radiogroup">
  <Radio
    {id}
    {selection}
    {options}
    {name}
    onChange={handleChange}
    componentClass="flex w-full flex-col gap-6 {componentClass}"
  />

  <div id="{id}-error" class="label mt-1 text-system-red" role="alert">
    {#if isInvalid && errorMessage}
      {errorMessage}
    {:else}
      &nbsp <!-- prevent layout shift -->
    {/if}
  </div>
</div>
